<template>
  <div class="app">
    <Navigation></Navigation>
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import Navigation from "@/components/Navigation.vue";

export default defineComponent({
  name: "HugoCohen",
  components: {
    Navigation,
  },
  setup() {
    useHead({
      title: "Home",
      titleTemplate: "%s | Hugo Cohen",
    });

    return {};
  },
});
</script>

<style lang="scss">
@import "styles/global.scss";

.app {
  height: 100vh;
  width: vw;
}
</style>
